import {
    SidebarInset,
    SidebarProvider, SidebarTrigger
} from "@/components/ui/sidebar.tsx";
import {AppSidebar} from "@/components/app-sidebar.tsx";
import {Separator} from "@/components/ui/separator.tsx";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator
} from "@/components/ui/breadcrumb.tsx";
import {Outlet, useLocation} from "react-router";
import React from "react";

export default function DashboardLayout() {
    const location = useLocation()
    const route = location.pathname.split("/").slice(1)

    const routes = [
        {
            selector: "documents",
            name: "Tanulmányok",
            children: [
                {
                    selector: /[0-9]+/,
                    name: "Szerkesztés"
                }
            ]
        },
        {
            selector: "database",
            name: "Adatbázis",
            children: [
                {
                    selector: "account",
                    name: "Fiók"
                },
                {
                    selector: "users",
                    name: "Felhasználók",
                    children: [
                        {
                            selector: /[0-9]+/,
                            name: "Szerkesztés"
                        }
                    ]
                }
            ]
        }
    ]

    function getBreadcrumbs(routes: any, route: string[]): string[] {
        const breadcrumbs = []
        for (const r of routes) {
            if (r.selector == route[0] || r.selector?.test?.(route[0])) {
                breadcrumbs.push(r.name)
                if (r.children && route.length > 1) {
                    breadcrumbs.push(...getBreadcrumbs(r.children, route.slice(1)))
                }
            }
        }
        return breadcrumbs
    }

    return (
        <SidebarProvider>
            <AppSidebar/>
            <SidebarInset>
                <header
                    className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
                    <div className="flex items-center gap-2 px-4">
                        <SidebarTrigger className="-ml-1"/>
                        <Separator
                            orientation="vertical"
                            className="mr-2 data-[orientation=vertical]:h-4"
                        />
                        <Breadcrumb>
                            <BreadcrumbList>
                                <BreadcrumbItem className="hidden md:block">
                                    <BreadcrumbLink href="#">
                                        Tanulmány Rendszer
                                    </BreadcrumbLink>
                                </BreadcrumbItem>
                                {
                                    getBreadcrumbs(routes, route).map((breadcrumb, index) => (
                                        <React.Fragment key={index}>
                                            <BreadcrumbSeparator/>
                                            <BreadcrumbItem key={index}>
                                                <BreadcrumbLink href="#">
                                                    {breadcrumb}
                                                </BreadcrumbLink>
                                            </BreadcrumbItem>
                                        </React.Fragment>
                                    ))
                                }
                            </BreadcrumbList>
                        </Breadcrumb>
                    </div>
                </header>
                <div
                    className={"h-[calc(100vh-4rem)] group-has-data-[collapsible=icon]/sidebar-wrapper:h-[calc(100vh-3rem)]"}>
                    <Outlet/>
                </div>
            </SidebarInset>
        </SidebarProvider>
    )
}